import { useNavigate } from "react-router-dom";
import Modal from "../modal/Modal";
import SubmitButton from "../submitButton/SubmitButton";
import TextComponent from "../textComponent/TextComponent";
import styles from "./RsvpModal.module.css";
import { RsvpIcon } from "../icons/Icons";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClearRSVP } from "../../Store/Actions/EventPlanningActions";

const RsvpModal = ({ rsvpModal, setrsvpModal, eventData }) => {
  const navigate = useNavigate();
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(ClearRSVP());
  // }, []);
  return (
    <Modal
      // pinkBg
      isModalOpen={rsvpModal}
      setIsModalOpen={setrsvpModal}
      closable={true}
      className={styles.modal}
    >
      <div className={styles.modalCon}>
        <RsvpIcon size={150} />
        <div className={styles.modalTxt}>
          <TextComponent text={"Send your requests for RSVPs"} />
        </div>
        <div className={styles.btnDiv}>
          <SubmitButton
            btnClass={styles.modalBtn}
            title={"Select Invitation From Template "}
            onClick={() =>
              navigate("/events/GreetingTemplate", {
                state: { headrTitle: "Greeting Templates", eventData },
              })
            }
          />
          <SubmitButton
            btnClass={styles.modalBtn}
            title={"Personalized Message "}
            onClick={() =>
              navigate("/events/RSVPPersonalized", {
                state: { headrTitle: "RSVP", eventData },
              })
            }
          />
        </div>
      </div>
    </Modal>
  );
};

export default RsvpModal;
